<template>
  <div>
    <template v-for="(why, index) in rootCause.analysisWhyBreakdown">
      <div v-if="why" :key="`${index}-${why}`" class="mb-3">
        <p class="body3 black--text ma-0 pa-0">
          <strong>{{ $t('problem_solving.analyse_tool.why') }} </strong
          >{{ why }}
        </p>
      </div>
    </template>

    <v-form class="mt-8">
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="rootCause.description"
            class="mb-4"
            outlined
            dense
            auto-grow
            rows="1"
            placeholder=" "
            hide-details
            :label="$t('problem_solving.problem_analysis.root_cause_analysis')"
          />
        </v-col>

        <v-col cols="12">
          <v-textarea
            v-model="rootCause.name"
            class="mb-4"
            outlined
            dense
            auto-grow
            hide-details
            rows="1"
            :placeholder="
              $t('problem_solving.root_causes.root_cause_name_placeholder')
            "
            :label="$t('problem_solving.root_causes.root_cause_name')"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="rootCause.type"
            class="mb-4"
            outlined
            dense
            hide-details
            :placeholder="$t('common.select')"
            :label="$t('common.type')"
            :items="typeOptions"
          />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
export default {
  name: 'SummaryStep',

  props: {
    rootCause: {
      type: Object,
      required: true,
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      typeOptions: this.$constants.problemSolving.rootCauseTypes.map(type => ({
        text: this.$t(type.name),
        value: type.value,
      })),
    }
  },
}
</script>
